import { Injectable } from "@angular/core";

export interface IOnlineChargeMediator {
    notifyOnlineCharge(sender: object, event: OnlineChargeEvents, message?: object | string): void
}

@Injectable({
    providedIn: 'root'
})
export class OnlineChargeMediator {
    notifyOnlineCharge(sender: object, event: OnlineChargeEvents, message?: object | string): void {};
}

export class OnlineChargeBaseComponent {
    constructor(protected mediator?: OnlineChargeMediator) {
        this.mediator = mediator!;
    }

    public setMediator(mediator: OnlineChargeMediator): void {
        this.mediator = mediator;
    }
}

export type OnlineChargeEvents = "INITIAL_STATE" | "AMOUNT_SELECTED" | "TERMS_AGREED";